import '../styles/icon-number.css'

const IconNumber = ({number, hideZero}) => {
  return (
    <div className={typeof number === 'number' ? `icon-number ${number > 99 ? 'icon-number--plus' : (hideZero && number <= 0 ? 'icon-number--hide' : (number <= 0 ? 'icon-number--zero' : ''))}` : 'icon-number--hide'}>{number > 99 ? '99+' : number}</div>
  )
}

export default IconNumber